import { Pipe, PipeTransform } from '@angular/core';
import { Observable, zip } from 'rxjs';
import { map } from 'rxjs/operators';

import { TravelerPaxResponse } from '@pax/entities/traveler-pax';
import { TravelerListVmPipe } from '@pax/pipes/traveler-list-vm.pipe';
import { TravelerTypes } from '@pax/entities/traveler-info';

@Pipe({
  name: 'fullValidTravelers',
  standalone: false
})
export class FullValidTravelersPipe implements PipeTransform {

  constructor(
    private travelerListVmPipe: TravelerListVmPipe,
  ) { }

  transform(
    travelersNotFormat: TravelerPaxResponse[],
    startDate: string = null
  ): Observable<TravelerPaxResponse[]> {
    const pipesFn$ = this.allTravelerPipes$(travelersNotFormat, startDate);
    return zip(...pipesFn$).pipe(
      map(response => {
        return response ? [].concat(...response) : [];
      })
    );
  }

  private allTravelerPipes$(
    travelersNotFormat: TravelerPaxResponse[], startDate: string
  ): Observable<TravelerPaxResponse[]>[] {
    return Object.values(TravelerTypes).map(type => {
      return this.travelerListVmPipe.transform(
        travelersNotFormat.map(_t => ({
          ..._t, ui: null
        })),
        type, 'NULL_UI', startDate
      );
    });
  }
}

